var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCienWh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.6 22",
    style: {
      enableBackground: "new 0 0 20.6 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1473.882 -33)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1485.7,41c-2.3-1.6-5.1-2.3-7.8-2c-0.2,0-0.5,0.1-0.7,0.3c-1,0.8-1.7,1.8-2.3,3c-1.3,2.7-2.2,8.1,2.1,11.6 l0.1,0.1c4.9,2.7,9.5-0.2,11.5-2.4c0.8-0.9,1.4-2,1.8-3.1c0.1-0.2,0.1-0.5,0-0.7C1489.8,44.9,1488.1,42.6,1485.7,41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1494.4,41.3c-0.7-2.1-2-4-3.8-5.4l0.9-1.3c0.2-0.3,0.1-0.8-0.2-1l-0.7-0.5c-0.3-0.2-0.8-0.1-1,0.2l-0.9,1.3 c-1.9-1.2-4.2-1.7-6.4-1.5c-2.2,0.5-3.9,2.2-4.5,4.3c0,0.1,0.1,0.2,0.2,0.3c0,0,0.1,0,0.1,0l0.1,0c1.1-0.3,4.3-0.5,8.4,2.2 c3.9,2.6,4.9,5.5,5.1,6.7c0,0.1,0,0.2,0,0.2c0,0.1,0.1,0.2,0.3,0.2c0,0,0.1,0,0.1,0C1493.9,45.7,1494.7,43.5,1494.4,41.3  M1487,39.1L1487,39.1L1487,39.1L1487,39.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCienWh);
export default __webpack_public_path__ + "static/media/cien_wh.d7a9fb1fd919d63b258206ac484f72e4.svg";
export { ForwardRef as ReactComponent };